(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.controller('YearoverviewDatepickerController', ['$uibModalStack', 'DateService', YearoverviewDatepickerControllerFn]);

    /* Controller for the yearoverview - datepicker */
    function YearoverviewDatepickerControllerFn($uibModalStack, DateService) {
        /* jshint validthis:true */
        var vm = this;
        var monthOfYear = 0;
        var selectedYear = 0;

        // current selected date
        vm.model = null;

        // settings for ui element
        vm.options = {
            initDate: null,
            showWeeks: true,
            startingDay: 1,
            yearRows: 1,
            yearColumns: 4,
            minMode: 'day',
            maxMode: 'day'            
        };

        // init controller
        vm.init = function (month, year) {
            monthOfYear = month;
            selectedYear = year;
            activate();
        };

        // change the date to the selected one
        vm.change = function () {            
            DateService.dateAndReload(vm.model);
            $uibModalStack.dismissAll();
        };

        //do Activation
        function activate() {
            // set dates for month
            var currentDate = new Date();
            var startOfMonthDate = new Date(selectedYear, monthOfYear, 1, 0, 0, 0, 0);
            var endOfMonthDate = new Date(selectedYear, monthOfYear + 1, 1, 0, 0, 0, 0);
            endOfMonthDate = new Date(endOfMonthDate.setDate(endOfMonthDate.getDate() - 1));
            
            vm.model = null;        // don't show a selected date in the year overview

            // set dates in options
            vm.options.minDate = startOfMonthDate;
            vm.options.maxDate = endOfMonthDate;
            vm.options.date = startOfMonthDate;

            // set current date => this property shows the correct month
            vm.options.initDate = startOfMonthDate;            
        }
    }
})();